import { render, staticRenderFns } from "./index.vue?vue&type=template&id=00d26dd0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d26dd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00d26dd0')) {
      api.createRecord('00d26dd0', component.options)
    } else {
      api.reload('00d26dd0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=00d26dd0&scoped=true", function () {
      api.rerender('00d26dd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/IChat/src/index.vue"
export default component.exports